// removed by extract-text-webpack-plugin
module.exports = {"before-launch-container":"_2L3_0oVQkpzKAGzOqkpfI_","section":"_2zh_MIrgLH2FXDkTjst4qd","teacher_section":"_1yz-ViHLMPbZhCXEOJh4Ar","section_header":"_2O2T-PF6dhCFeElo7wlKBZ","spaceBetween":"_1rsMmuFQQ5pbPocdlHeEf2","section_header_addButton":"_3sIlfFPK4_4oVozcrtiMuj","section_content":"_2W7HRwyNUvQ3nBaSAYXFjc","section_content_list":"wTVVMF_AsmwVR-yRCvVGe","section_content_list_editWrapper":"_1wj4UOAC_oiFPgGFn32h8R","section_content_list_deleteButton":"_2SNIYAAtJUzi-LA9nRfKWp"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LecturePage/lecture-item.scss
// module id = 89
// module chunks = 0